import { render, staticRenderFns } from "./config-base.vue?vue&type=template&id=09eae574&scoped=true"
import script from "./config-base.vue?vue&type=script&lang=ts"
export * from "./config-base.vue?vue&type=script&lang=ts"
import style0 from "./config-base.vue?vue&type=style&index=0&id=09eae574&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09eae574",
  null
  
)

export default component.exports